import HowToVideo from '../components/HowToVideo'
import HowToRow from '../components/HowToRow'
import { createApp } from 'vue';
import BootstrapVueNext from 'bootstrap-vue-next'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import PrintDropdown from '../components/PrintDropdown';

if (document.getElementById('how-to-row')) {
    const app = createApp({
        components: {
            HowToVideo,
            HowToRow,
            PrintDropdown,
        },
        data() {
            return {
              video: {
                title: 'Go NAP SACC How-To Video: Self-Assessment',
                assessmentURL: 'https://www.youtube.com/embed/iLLjYLEJqrA?ecver=2&modestbranding=1&autoplay=0&showinfo=0&enablejsapi=1&rel=0'
              }
            };
          }
    });
    app.use(BootstrapVueNext);
    app.mount('#how-to-row');
}

import ProgramAssessments from '../components/ProgramAssessments'
if (document.getElementById('assessments_component')) {
    const app = createApp({
        components: {
            'assessments': ProgramAssessments
        },
        functions:{
        },
        mounted: function () {
        }
    });
    app.use(BootstrapVueNext);
    app.mount('#assessments_component');
}

